import { useMemo } from 'react';
import { exportReportFile, processReport } from '../../../../utils/reports';
import { BILLING_COLUMNS } from '../../../../constants/reports';
import ReportList from '../ReportList';
import ReportActionRow from '../ReportActionRow';

function ReportBilling({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={processedReport}
        tableColumns={BILLING_COLUMNS}
        headerHeight={36}
        rowKey="consumerId"
      />
    </>
  );
}

export default ReportBilling;
